import { ItemTypes } from '~constants/ItemTypes';
import { IItem } from '~api/interfaces/IItem';
import { IProductParams, ISkuParams } from '~api/interfaces/IParams';

type ItemByType = { [K in ItemTypes]: ISkuParams[] | IProductParams[] };

export interface IItemByType extends ItemByType {
    [K: string]: ISkuParams[] | IProductParams[];
}

export const splitItemByType = (items: IItem[]) => {
    const itemsByType = Object.keys(ItemTypes).reduce((keys, key) => {
        keys[key] = [];

        return keys;
    }, {} as IItemByType);

    return items.reduce((separatedItems, item: IItem) => {
        separatedItems[item.type].push(item.params);

        return separatedItems;
    }, itemsByType);
};
